<div class="flex flex-row w-full h-full">
  <!-- Sidebar: animate width instead of hiding -->
  <div
    class="transition-all duration-500 ease-in-out overflow-hidden w-0 md:w-52 md:overflow-visible"
  >
    <app-sidenav />
  </div>

  <!-- Main content: animate margin-left -->
  <div class="flex-1 bg-light-bg overflow-auto scroll-smooth">
    <!-- Header: Show when the screen is too small -->
    <div class="block md:hidden">
      <app-header class="fixed top-0 w-full z-60" />
    </div>

    <div class="flex-1 p-4 pt-14 md:p-8 md:pt-8 h-full">
      <router-outlet class="w-full h-full" />
    </div>
  </div>
</div>
